// src/pages/ArticlePage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Home from './Home';
import { fetchPosts } from '../utils/cmsAPI';
import { getArticleSlug } from '../utils/slugUtils';

const ArticlePage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArticle = async () => {
      try {
        const posts = await fetchPosts({ published: true });
        const foundArticle = posts.find(post => getArticleSlug(post) === slug);
        
        if (foundArticle) {
          setArticle(foundArticle);
        } else {
          // Article not found, redirect to home
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Failed to fetch article:', error);
        navigate('/', { replace: true });
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      loadArticle();
    }
  }, [slug, navigate]);

  // Pass the article to Home component which will open the drawer
  return <Home articleSlug={slug} article={article} loading={loading} />;
};

export default ArticlePage;

